'use es6';

import { transform } from 'AdsUI/lib/Transform';
import { OrderedSet, Set as ImmutableSet } from 'immutable';
import AdWordsTemplateAdEntityRecord from 'AdsUI/records/ad-management/AdWordsTemplateAdEntityRecord';
import AdWordsTextAdEntityRecord from 'AdsUI/records/ad-management/AdWordsTextAdEntityRecord';
import AdWordsKeywordEntityRecord from 'AdsUI/records/rmf/AdWordsKeywordEntityRecord';
import AdWordsAdGroupEntityRecord from 'AdsUI/records/rmf/AdWordsAdGroupEntityRecord';
import AdWordsCampaignEntityRecord from 'AdsUI/records/rmf/AdWordsCampaignEntityRecord';
import AdWordsNetworkSettingsRecord from 'AdsUI/records/rmf/AdWordsNetworkSettingsRecord';
import AdWordsBiddingStrategyConfigurationEntityRecord from 'AdsUI/records/rmf/AdWordsBiddingStrategyConfigurationEntityRecord'; // Transform Functions

export const stringify = value => {
  if (value === null) {
    return value;
  }

  return `${value}`;
};
export const construct = type => {
  return obj => {
    return new type(obj);
  };
};
export const listConstruct = (ListType, transformFn) => {
  return arr => {
    const list = arr.map(obj => {
      return transformFn(obj, {
        shouldConstruct: true
      });
    });
    return new ListType(list);
  };
}; // partial transforms

export const idStringifyTransform = transform({
  id: stringify
});
export const adWordsChildEntityTransform = transform({
  id: stringify,
  adGroupId: stringify
});
export const adWordsKeywordEntityTransform = transform({
  id: stringify,
  adGroupId: stringify,
  biddingStrategyConfiguration: construct(AdWordsBiddingStrategyConfigurationEntityRecord),
  __constructor: AdWordsKeywordEntityRecord
});
export const adWordsTextAdEntityTransform = transform({
  id: stringify,
  adGroupId: stringify,
  __constructor: AdWordsTextAdEntityRecord
});
export const adWordsTemplateAdEntityTransform = transform({
  id: stringify,
  adGroupId: stringify,
  __constructor: AdWordsTemplateAdEntityRecord
});
export const adWordsAdGroupEntityTransform = transform({
  id: stringify,
  campaignId: stringify,
  biddingStrategyConfiguration: construct(AdWordsBiddingStrategyConfigurationEntityRecord),
  keywords: listConstruct(OrderedSet, adWordsKeywordEntityTransform),
  textAds: listConstruct(OrderedSet, adWordsTextAdEntityTransform),
  templateAds: listConstruct(OrderedSet, adWordsTemplateAdEntityTransform),
  partitions: listConstruct(ImmutableSet),
  __constructor: AdWordsAdGroupEntityRecord
});
export const adWordsCampaignEntityTransform = transform({
  id: stringify,
  adGroups: listConstruct(ImmutableSet, adWordsAdGroupEntityTransform),
  biddingStrategyConfiguration: construct(AdWordsBiddingStrategyConfigurationEntityRecord),
  networkSetting: construct(AdWordsNetworkSettingsRecord),
  __constructor: AdWordsCampaignEntityRecord
});